export const Login = () => {
  return (
    <svg viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 13L9 9L5 5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 9H1"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.66699 1H13.2225C13.694 1 14.1462 1.1873 14.4796 1.5207C14.813 1.8541 15.0003 2.30628 15.0003 2.77778V15.2222C15.0003 15.6937 14.813 16.1459 14.4796 16.4793C14.1462 16.8127 13.694 17 13.2225 17H9.66699"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
